// extracted by mini-css-extract-plugin
module.exports = {"spinningWheel":"style-module--spinningWheel--2dF9M"};